module.exports = __webpack_public_path__ + "img/monitor.27cc630e.png";